import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { TypeCoord } from '../models/TypeCoord';
@Component({
  selector: 'app-type-coord',
  templateUrl: './type-coord.component.html'
})
export class TypeCoordComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCoord';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() coord: TypeCoord;


  public step12 = new Step12();

  constructor() { }

  public ngOnInit() {}
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

